<template>
  <footer class="footer">
    © {{currentYear}} - binds.co  - CNPJ 23.621.217/0001-14
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  status: 'prototype',
  release: '1.0.0',
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.footer {
  @include reset();
  position: relative;
  padding: 26px;
  background: $color-white;
  font-family: $font-text;
  font-size: $size-xs;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: right;
  color: $color-purple-darker;
}
</style>
